module.exports = __webpack_public_path__ + "static/img/Christian-Welch.df209d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Christian-Welch.jpg
// module id = jIb7
// module chunks = 0